import s from "./title-menu.css";

export const styles = s;

export default `
<canvas id="js-rain" class="${s["rain"]}"></canvas>
<div class="${s["title-wrapper"]}">
  <div class="${s["fire-wrapper"]}">
    <canvas class="${s["fire"]}" id="js-shadow-text" width="640" height="100"></canvas>
    <canvas class="${s["fire"]}" id="js-fire-text" width="640" height="100"></canvas>
  </div>

  <div class="${s["title-menu-options"]}">
    <div class="${s["title-menu-option"]}" tabindex="0"><a href="/minetown?new-game">NEW GAME</a></div>
    <div class="${s["title-menu-option"]} ${s["title-menu-option--disabled"]}" tabindex="1" id="js-load-game">
      LOAD GAME
    </div>
    <div class="${s["title-menu-option"]}" tabindex="2"><a href="/encourage-matt">ENCOURAGE MATT</a></div>
    <div class="${s["title-menu-option"]}" tabindex="3"><a href="https://www.mtmckenna.com">QUIT</a></div>
  </div>
  <!-- Begin Mailchimp Signup Form -->
  <div class="${s["email-newsletter-wrapper"]}" id="mc_embed_signup">
    <form
      action="https://app.us20.list-manage.com/subscribe/post?u=b53f362e2527a2112f819ca21&amp;id=f1fe66106f"
      method="post"
      id="mc-embedded-subscribe-form"
      name="mc-embedded-subscribe-form"
      class="validate ${s["email-newsletter-form"]}"
      target="_blank"
      novalidate
    >
      <div id="mc_embed_signup_scroll">
        <div class="${s["sign-up-reason"]}">
          Sign up for the newsletter, and I'll send you a movie recommendation!
        </div>
        <div class="${s["form-inputs"]}">
          <input
            type="email"
            value=""
            name="EMAIL"
            class="required ${s["email-input"]}"
            id="mce-EMAIL"
            placeholder="Your email address"
          />
          <button
            type="submit"
            value="Subscribe"
            name="subscribe"
            id="mc-embedded-subscribe"
            class="${s["button"]}"
          >
            Subscribe!
          </button>
        </div>
        <div id="mce-responses" class="clear">
          <div class="response" id="mce-error-response" style="display:none"></div>
          <div class="response" id="mce-success-response" style="display:none"></div>
        </div>
        <!-- real people should not fill this in and expect good things - do not remove this or risk form bot signups-->
        <div style="position: absolute; left: -5000px;" aria-hidden="true">
          <input type="text" name="b_b53f362e2527a2112f819ca21_f1fe66106f" tabindex="-1" value="" />
        </div>
      </div>
    </form>
  </div>

  <!--End mc_embed_signup-->
  <div class="${s["copyright"]}">&copy; 2020 Matt</div>
</div>
`;
